import React from 'react';

import RegiterUser from '../components/container/RegisterUser';

const Register = () => {
  return <RegiterUser />;
};

export default Register;
